export default "__VITE_ASSET__CCNFOLaN__"